import { Step } from 'react-joyride';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Link from '@mui/material/Link';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TourGuide } from '../../../../components';

type TTeamTour = {
  runTour: boolean
  handleFinishTour: () => void
};

const TeamTour: FC<TTeamTour> = ({ runTour, handleFinishTour }) => {
  const { t } = useTranslation('tour');

  const tourSteps: Array<Step> = [
    {
      target: '#team-locations',
      disableBeacon: true,
      content: t('thisIsTheTeamLocationFilter'),
    },
    {
      target: '#fade-button',
      disableBeacon: true,
      content: t('hereYouHaveTwoOptions'),
    },
    {
      target: '#guide-arrows',
      disableBeacon: true,
      content: t('useTheseArrowsToNavigate'),
    },
    {
      target: '#team-shopifyId',
      disableBeacon: true,
      placement: 'bottom',
      content: (
        <Box>
          <Typography variant="body1" gutterBottom>
            {t('theShopifyIdAEssential')}
          </Typography>
          <List component="ol">
            <ListItem>
              <Typography variant="body2">
                <strong>{t('loginToShopify')}</strong>
                {' '}
                {t('goTo')}
                {' '}
                <Link href="https://www.shopify.com/login" target="_blank" rel="noopener noreferrer">
                  {t('shopifyAdmin')}
                </Link>
                {' '}
                {t('andSignIn')}
              </Typography>
            </ListItem>
            <ListItem>
              <Typography variant="body2">
                <strong>{t('goToSettings')}</strong>
                {' '}
                {t('inTheLeftSidebar')}
                <em>{t('settings')}</em>
                ,
                {' '}
                {t('thenChoose')}
                {' '}
                <em>{t('usersAndPermissions')}</em>
                .
              </Typography>
            </ListItem>
            <ListItem>
              <Typography variant="body2">
                <strong>{t('selectTheTeamMember')}</strong>
                {' '}
                {t('clickOnTheTeamMember')}
              </Typography>
            </ListItem>
            <ListItem>
              <Typography variant="body2">
                <strong>{t('findTheShopifyId')}</strong>
                {' '}
                {t('inTheTeamMembersProfilePage')}
                {' '}
                <code>https://your-store.myshopify.com/admin/settings/users/1234567890</code>
                .
              </Typography>
            </ListItem>
            <ListItem>
              <Typography variant="body2">
                <strong>{t('copyTheId')}</strong>
                {' '}
                {t('useThisIdInOurApp')}
              </Typography>
            </ListItem>
          </List>
        </Box>
      ),
    },
    {
      target: '#team-pincode',
      disableBeacon: true,
      content: t('thePinCodeIsUnique'),
    },
    {
      target: '#edit-icon',
      disableBeacon: true,
      content: t('clickHereToEditTheDetails'),
    },
    {
      target: '#delete-icon',
      disableBeacon: true,
      content: t('clickHereToDeleteATeamMember'),
    },
  ];

  return (
    <TourGuide steps={tourSteps} run={runTour} onFinish={handleFinishTour} />
  );
};

export {
  TeamTour,
};
